import React from "react";

const Christmas = ({style = {}, size = "36", className = "", fill = "#73788B", viewBox = "0 0 36 36"}) => (
    <svg
        width={size}
        style={style}
        height={size}
        viewBox={viewBox}
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
        className={`${className || ""}`}
        xmlnsXlink="http://www.w3.org/1999/xlink"
    >
        <path
            className="u_fill"
            d="M30.75 27.886l-3.067-4.909c-.824.69-2.73 2.168-5.545 3.665a36.424 36.424 0 01-6.458 2.679v3.742c0 .517.42.937.938.937h3.656c.518 0 .938-.42.938-.937V29.32h8.743a.937.937 0 00.795-1.434zM21.2 25.02c1.491-.79 2.72-1.58 3.647-2.235a16.618 16.618 0 01-3.58-.823c-1.702-.589-3.429-1.46-5.133-2.59a28.78 28.78 0 01-4.454-3.644l-2.096 3.043a.938.938 0 00.772 1.47h.565l-4.779 7.647a.937.937 0 00.043 1.057c6.46-.095 11.732-2.187 15.016-3.926zm-6.055-2.977c.69 0 1.25.563 1.25 1.257s-.56 1.257-1.25 1.257-1.25-.563-1.25-1.257c0-.695.56-1.257 1.25-1.257zM20.895 7.227L19.27 4.985A1.606 1.606 0 0018.447 2a1.605 1.605 0 00-.823 2.985l-5.408 7.457a.937.937 0 00.227 1.322c5-.752 7.453-4.459 8.452-6.537zM19.329 12.463a12.3 12.3 0 01-5.314 2.894 27.59 27.59 0 003.195 2.476c2.241 1.48 5.59 3.16 9.236 3.163l-.474-.758h.565a.938.938 0 00.772-1.47l-3.335-4.84a.938.938 0 00.703-1.487l-2.552-3.52a14.37 14.37 0 01-2.796 3.542zm.891 5.423c-.69 0-1.25-.563-1.25-1.257s.56-1.257 1.25-1.257 1.25.563 1.25 1.257-.56 1.257-1.25 1.257z"
            fill={fill}
        />
    </svg>
);

export default Christmas;